module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M30 0H6C4.9 0 4 .9 4 2H2C.9 2 0 2.9 0 4s.9 2 2 2h2v2H2c-1.1 0-2 .9-2 2s.9 2 2 2h2v2H2c-1.1 0-2 .9-2 2s.9 2 2 2h2v2H2c-1.1 0-2 .9-2 2s.9 2 2 2h2v2H2c-1.1 0-2 .9-2 2s.9 2 2 2h2c0 1.1.9 2 2 2h24c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2zm-5 12H11a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1zm0 6H11a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1zm0 6H11a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/notebook-2.js
// module id = 1308
// module chunks = 14